import { render, staticRenderFns } from "./DiscountMarginDialog.vue?vue&type=template&id=101ec436"
import script from "./DiscountMarginDialog.vue?vue&type=script&lang=js"
export * from "./DiscountMarginDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports